import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import iosInstruction from "../../Assets/photo/ios_pwa_instruction.png";
import androidInstruction from "../../Assets/photo/android_pwa_instruction.png";
import biomeLogo from "../../Assets/photo/biomelogo.png";
import "../../Assets/css/PwaInstructionModal.css";
import { FaApple, FaAndroid } from "react-icons/fa";

const PwaInstructionModal = ({ show, onHide }) => {
  const [activeTab, setActiveTab] = useState("ios"); // 'ios' or 'android'

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      scrollable
      className="pwa-instruction-modal"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="w-100 mb-0 text-center">
          <h5 className="mb-0 fw-bold">
            Add Home Screen Shortcut {activeTab === "ios" ? "IOS" : "Android"}
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-2 px-4 pb-4 mt-3 text-center">
        {activeTab === "ios" ? (
          <img
            src={iosInstruction}
            alt="iOS instructions"
            className="img-fluid rounded shadow-sm mb-4"
          />
        ) : (
          <img
            src={androidInstruction}
            alt="Android instructions"
            className="img-fluid rounded shadow-sm mb-4"
          />
        )}

        <div className="d-flex justify-content-center gap-3 mb-4">
          <button
            className={`btn rounded-pill d-flex align-items-center gap-2 ${activeTab === "ios" ? "btn-dark text-white fw-bold" : "btn-light text-dark fw-bold border"}`}
            onClick={() => setActiveTab("ios")}
          >
            <FaApple size={20} /> IOS
          </button>
          <button
            className={`btn rounded-pill d-flex align-items-center gap-2 ${activeTab === "android" ? "btn-dark text-white fw-bold" : "btn-light text-dark fw-bold border"}`}
            onClick={() => setActiveTab("android")}
          >
            <FaAndroid size={20} /> Android
          </button>
        </div>

        <div className="text-start px-md-3">
          {activeTab === "ios" ? (
            <ol className="pwa-steps mb-4 fw-medium text-secondary">
              <li>Tap the bottom arrow up button</li>
              <li>Go to "Add to Home Screen"</li>
              <li>Click "Add" at top right</li>
              <li>Web App is now added in your home</li>
            </ol>
          ) : (
            <ol className="pwa-steps mb-4 fw-medium text-secondary">
              <li>Tap the top right 3 buttons icon</li>
              <li>Go to "Add to Home Screen"</li>
              <li>Click "Install" Option</li>
              <li>Continue with "Install" App</li>
              <li>Web App is now added in your home</li>
            </ol>
          )}
        </div>

        <div className="d-flex align-items-center justify-content-center gap-2 mt-4">
          <img
            src={biomeLogo}
            alt="BioME"
            height={24}
            width={24}
            className="rounded"
          />
          <span className="fw-bold text-dark border-bottom border-dark border-2 pb-1">
            BioME Website
          </span>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PwaInstructionModal;
